import type { Mutation, MutationUpdateShoppingListNameArgs } from '@ab-core/graphql/dist';
import { useMutation } from '@apollo/client';
import { useEffect, useState } from 'react';
import { getErrorLoggerFunction } from '../utils';
import { SHOPPING_LISTS } from './gql/shoppingLists';
import { UPDATE_SHOPPING_LIST_NAME } from './gql/updateShoppingListName';

type MutationDataType = Pick<Mutation, 'updateShoppingListName'>;
type ResponseDataType = MutationDataType | undefined;

const onError = getErrorLoggerFunction('updateShoppingListName');

const refetchQueries = [SHOPPING_LISTS];

export const useUpdateShoppingListName = (id: string, newName: string) => {
    const [response, setResponse] = useState<ResponseDataType>(undefined);

    const [updateShoppingListName, { loading, error, data }] = useMutation<
        MutationDataType,
        MutationUpdateShoppingListNameArgs
    >(UPDATE_SHOPPING_LIST_NAME, {
        variables: {
            id,
            shoppingListInput: {
                name: newName?.trim()
            }
        },
        refetchQueries,
        onError
    });

    useEffect(() => {
        if (data) {
            setResponse(data);
        }
    }, [data]);

    return {
        error: !!error && !loading,
        success: !!data && !loading,
        updateShoppingListName,
        loading,
        response
    };
};
